import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const services = [
    {
        id: "01",
        title: "Business Documentation & Planning",
        desc: "We manage complete project documentation, technical reports, and digital workflows ensuring clarity, compliance, and smooth execution for businesses in Dubai and the UAE.",
        icon: "mdi:file-document-edit-outline",
    },
    {
        id: "02",
        title: "Wireframing & Strategy",
        desc: "Our team creates detailed wireframes and digital blueprints that define your website or application structure laying a strong foundation before development begins.",
        icon: "mdi:vector-square",
    },
    {
        id: "03",
        title: "UI/UX Design",
        desc: "We design modern, intuitive, and user-focused interfaces that deliver seamless digital experiences across web and mobile platforms aligned with Dubai’s global standards.",
        icon: "mdi:palette-outline",
    },
    {
        id: "04",
        title: "Software Development",
        desc: "From web platforms to mobile applications, we develop secure, scalable, and high-performance digital solutions tailored for growing businesses in Dubai.",
        icon: "mdi:code-block-tags",
    },
    {
        id: "05",
        title: "A/B Testing & Optimization",
        desc: "We conduct in-depth A/B testing to analyze user behavior, improve engagement, and maximize conversions, driving measurable digital growth.",
        icon: "mdi:compare",
    },
    {
        id: "06",
        title: "Deployment & Support",
        desc: "We ensure smooth, secure, and reliable deployment with minimal downtime—backed by continuous monitoring and technical support across the UAE",
        icon: "mdi:cloud-upload-outline",
    },
];

export default function ItSolutionWorkingPattern() {
    const cardsRef = useRef([]);

    useEffect(() => {
        gsap.fromTo(
            cardsRef.current,
            { opacity: 0, y: 50 },
            {
                opacity: 1,
                y: 0,
                duration: 0.8,
                stagger: 0.2,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: cardsRef.current,
                    start: "top 85%",
                },
            }
        );
    }, []);

    const handleMouseEnter = (el) => {
        gsap.to(el, {
            backgroundColor: "#ffffff",
            // hover:bg-[#F26A33] hover:text-white
            color: "#000",
            duration: 0.4,
            ease: "power2.out",
        });
    };

    const handleMouseLeave = (el) => {
        gsap.to(el, {
            backgroundColor: "#1a1a1a",
            color: "#fff",
            duration: 0.4,
            ease: "power2.inOut",
        });
    };

    return (
        <section className="bg-black text-white md:py-20 py-0 px-5 md:px-16">
            <div className="max-w-screen-2xl mx-auto ">
                <button className="bg-white/10 border border-white/20 px-5 py-2 rounded-full text-sm mb-6 hover:bg-white/20 transition-all flex">
                    <Icon
                        icon="material-symbols:lightbulb-2-rounded"
                        className="mr-1.5 text-[#F26A33] drop-shadow-[0_0_6px_#F26A33]"
                        width="22"
                        height="20"
                    />

                    {/* SERVICES working pattern */}
                    {/* WORKING PATTERN */}
                    HOW WE WORK?
                </button>

                <h1
                    // ref={headingRef}
                    className="text-4xl md:text-7xl font-light leading-snug text-gray-400 max-w-screen-md mb-12"
                >
                    Reliable IT & Digital Solutions{" "}
                    <span className="text-white font-normal"> for Smarter Business</span>{" "}
                     Growth in Dubai
                </h1>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 ">
                    {services.map((service, index) => (
                        <div
                            key={service.id}
                            ref={(el) => (cardsRef.current[index] = el)}
                            onMouseEnter={(e) => handleMouseEnter(e.currentTarget)}
                            onMouseLeave={(e) => handleMouseLeave(e.currentTarget)}
                            className="relative bg-[#171717] rounded-2xl md:p-8 p-4 shadow-lg transition-all cursor-pointer group"
                        >
                            <div className="flex items-center justify-between mb-4">
                                <div className="w-20 h-20 flex items-center justify-center rounded-full bg-black/60  text-[#F26A33] group-hover:bg-[#F26A33] group-hover:text-white text-4xl transition-transform duration-500 group-hover:scale-110 mb-6  group-hover:rotate-y-[360deg]">
                                    <Icon icon={service.icon} />
                                </div>
                                <div className="absolute -top-0 right-0 bg-[#000000] px-8 py-4 rounded-xl rounded-r-none rounded-tl-none">
                                    <span className="text-2xl text-gray-400 group-hover:text-[#F26A33] font-semibold ">.{service.id}</span>
                                </div>

                                <span className="text-xl font-semibold opacity-50"></span>
                            </div>

                            <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
                            <p className="text-gray-400 mb-2 leading-relaxed">{service.desc}</p>
                            <a
                                href="#"
                                className="text-sm font-medium inline-flex items-center gap-1 hover:underline"
                            >
                                {/* Learn More <Icon icon="mdi:arrow-right" className="text-base" /> */}
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

